









































































































































































































































































































































































































































































































































































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, onMounted, reactive, ref, SetupContext } from '@vue/composition-api';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import axios, { AxiosResponse } from 'axios';
// Refer: https://www.tiny.cloud/docs/integrations/vue/
import Editor from '@tinymce/tinymce-vue';
import { v4 as uuidv4 }from 'uuid';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Template = {
  id: string,
  name: string,
  created_at: string,
  updated_at: string,
  organization_id: string,
  is_vertical: boolean,
  has_description: boolean,
  has_image: boolean,
  has_spec: boolean,
};

type Project = {
  id: string,	
	organization_id: string,
	user_id: string,       
	name: string,         
	supplemental_memo: string,
	internal_memo: string,
  default_cp_template_id: string,
	is_archived: boolean,
	created_at: string,    
	updated_at: string,  
};

type Concept = {
	id: string,
	project_id: string,
	cp_template_id: string,
	name?: string,
	title?: string,
	description?: string,
  image_vertical_size?: number,
	topbox?: number,
	sum_of_top2box?: number,
  spec_style: string,
	created_at: string,
	updated_at: string,

  concept_image_id: string,
  cpcard_image_id: string,

  project_name: string 
};

type Spec = {
	id: string,
	concept_id: string,
	name: string,
	content: string,
	created_at: string,
	updated_at: string,
  name_placeholder: string,
  content_placeholder: string,
};

type Props = {
  id: string;
};

export default defineComponent({
  name: "ConceptEdit02",
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    'editor': Editor,
    NavHeader,
    Footer
  },
  head: {
    link: [
      //{ rel: 'stylesheet', type: 'text/css', href: 'https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/spectrum.min.css' },
      { rel: 'stylesheet', type: 'text/css', href: '/css/login/project.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      //{ src: "https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/spectrum.min.js" },
      //{ src: "https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/i18n/jquery.spectrum-ja.min.js" },
      { src: "/js/toggle_contents.js" },
      { src: "/js/project.js" },
      { src: "/js/paretto.js", body: true },
    ]
  },

  setup(props: Props, context: SetupContext) {
    const state = reactive({
      paretto: 'default',
      projectName: '',
      beingDeletedSpecID: '',
      concept: {} as Concept,
      imageFile: null as File | null, 
      imageData: '',
      specs: [
        { id: uuidv4(), name: '', content: '', name_placeholder: '価格', content_placeholder: '330円（税込み）' },
        { id: uuidv4(), name: '', content: '', name_placeholder: '売り場', content_placeholder: 'コンビニエンスストア' },
        { id: uuidv4(), name: '', content: '', name_placeholder: '味', content_placeholder: '○○○○○○○○○○○○○○○風味' }
      ] as Spec[],
    });

    async function load() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {
          pid: '',
          cid: ''
        }
      }

      API.get('dev', '/concepts/' + props.id, options).then(response => {
        console.log(response);
        state.projectName = response.data.project_name;

        state.concept = response.data.concept;
        state.concept.title = state.concept.title || '';
        state.concept.description = state.concept.description || '';
        state.concept.spec_style = state.concept.spec_style || 'single-column';

        if (state.concept.concept_image_id !== null) {
          options.queryStringParameters.pid = state.concept.project_id;
          options.queryStringParameters.cid = state.concept.id;
          console.log(options);
          API.get('dev', '/images/cpimages/' + state.concept.concept_image_id, options).then(response => {
            state.imageData = response.data.url
          }).catch(err => {
            console.log(err);
          })
        }

        if (response.data.specs !== null) {
          state.specs = response.data.specs;
        }
      }).catch(err => {
        console.log(err);
      });
    }
    load();

    async function uploadImage(): Promise<AxiosResponse<any>> {
      const options = {
        baseURL: `${(await API.endpoint('dev'))}`,
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        }
      };
      const api = axios.create(options);

      const data = new FormData();
      if (state.imageFile !== null) {
        data.append("name", state.imageFile.name);
        data.append("image", state.imageFile, state.imageFile.name);
        data.append("pid", state.concept.project_id);
        data.append("cid", state.concept.id);

        return api.post('/images/cpimages', data);
      } else {
        return Promise.reject("Image data is empty");
      }
    }

    async function updateConcept() {
      console.log(state);

      await uploadImage().then(response => {
        console.log(response.data);
        console.log(response.data.data[0]);
        state.concept.concept_image_id = response.data.data[0].id;
      }).catch(err => {
        console.log(err);
      });

      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        body: {
          concept: state.concept,
          specs: state.specs,
        }
      }

      console.log(state.concept)
      API.put('dev', '/concepts/' + props.id, options).then(response => {
        console.log(response);
        context.root.$router.push({ name: 'ConceptGenerator', params: { id: response.data.concept.id } });
      }).catch(err => {
        console.log(err);
      });
    }

    function changeParetto(name: string, event: Event) {
      state.paretto = name;
    }

    function selectFile(e: Event) {
      const target = e.target as HTMLInputElement
      const files = target.files as FileList

      if (files.length > 0) {
        const reader = new FileReader();
        reader.onload = (e: Event) => {
          state.imageData = reader.result as string
        };
        reader.readAsDataURL(files[0]);
        state.imageFile = files[0];
      }
    }

    function addSpec() {
      state.specs.push({ id: uuidv4() } as Spec);
    }

    function deleteSpec(id: string) {
      state.specs = state.specs.filter((spec) => spec.id !== id);
    }

    return {
      state,
      updateConcept,
      changeParetto,
      selectFile,
      addSpec,
      deleteSpec,
    };
  }
});
